<template>
  <section class="section pt-5">
    <div class="container">
      <!-- Encabezado -->
      <div class="level mb-5">
        <div class="level-left">
          <div class="level-item">
            <div>
              <h1 class="title">{{ $t("status_management") }}</h1>
              <p class="subtitle">{{ $t("manage_ticket_status") }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- DataTable de estados -->
      <status-datatable />
    </div>
  </section>
</template>

<script>
import StatusDataTable from "./status_datatable/Index.vue";

export default {
  name: "HelpdeskStatus",
  components: {
    "status-datatable": StatusDataTable,
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}
</style>
